import { type ReactNode } from 'react';

export interface StatusConfig {
  /** CSS classes for the status badge styling */
  colorClasses: string;
}

/** Generic interface that all status implementations must extend */
export interface BaseStatus {
  getConfig(): StatusConfig;
}

export enum StatusBadgeType {
  Project = 'project',
  TeamMember = 'teamMember',
  Client = 'client',
  Invoice = 'invoice',
  Bill = 'bill',
  Assignment = 'assignment',
  TimeEntry = 'timeEntry',
  TimeOff = 'timeOff',
  Overhead = 'overhead',
}

export enum StatusBadgeSize {
  Default = 'default',
  Sm = 'sm',
}

export interface StatusBadgeProps {
  type: StatusBadgeType;
  status: string | undefined;
  /** Badge content — usually text, but may include an icon (e.g. overhead type badges). */
  label: ReactNode;
  /** Compact variant for dense surfaces (e.g. planner tooltip). */
  size?: StatusBadgeSize;
  warningTooltip?: string;
  infoTooltip?: string;
}
